var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('report-template-list-dialog', {
    attrs: {
      "templates": _vm.getReportTemplateList,
      "loading": _vm.loading
    },
    on: {
      "edit": _vm.handleEdit,
      "delete": _vm.handleDelete
    }
  }), _c('report-template-name-dialog')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }